"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _icon = _interopRequireDefault(require("../icon"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles(theme) {
  return {
    formControl: {// Specify a more appropriate min width so that the field is wide enough to cover most labels
      // minWidth: 120
    },
    flip: {
      transform: 'scaleY(-1)'
    }
  };
};

var SelectOrder = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(SelectOrder, _React$PureComponent);

  var _super = _createSuper(SelectOrder);

  function SelectOrder() {
    var _this;

    (0, _classCallCheck2.default)(this, SelectOrder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function () {
      var sortOrder = _this.props.sortOrder === 'ASC' ? 'DESC' : 'ASC';

      _this.props.onChange({
        sortOrder
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (event) {
      _this.props.onChange({
        sortBy: event.target.value
      });
    });
    return _this;
  }

  (0, _createClass2.default)(SelectOrder, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          sortBy = _this$props.sortBy,
          sortOrder = _this$props.sortOrder,
          options = _this$props.options;
      var flipped = sortOrder !== 'DESC';
      var items = options.map(function (option) {
        return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
          value: option.value,
          key: option.value
        }, option.label);
      }); // If we wanted the icon as an adornment:
      // <TextField
      //   select
      //   InputProps={{
      //     startAdornment:
      //     <InputAdornment position="start">
      //       <IconButton color="primary" aria-label="new" onClick={this.handleOrder}>
      //         <Icon icon="Sort" className={classes.flip} />
      //       </IconButton>
      //     </InputAdornment>,
      //   }}
      // >
      //   <MenuItem value={10}>Ten</MenuItem>
      //   <MenuItem value={20}>Twenty</MenuItem>
      //   <MenuItem value={30}>Thirty</MenuItem>
      // </TextField>

      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_FormControl.default, {
        className: classes.formControl
      }, /*#__PURE__*/_react.default.createElement(_Select.default, {
        value: sortBy,
        onChange: this.handleChange
      }, /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        value: ""
      }, /*#__PURE__*/_react.default.createElement("em", null, "None")), items)), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        color: "primary",
        "aria-label": "sort order",
        onClick: this.handleClick
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        icon: "Sort",
        className: flipped ? classes.flip : null
      })));
    }
  }]);
  return SelectOrder;
}(_react.default.PureComponent);

var _default = (0, _withStyles.default)(styles)(SelectOrder);

exports.default = _default;